<div class="welcome-module">
    <span>You are logged in as: </span>
    <span name="welcome-user">{{userName}}</span>
    <span name="welcome-user"><a style="color: blue;" href="https://chevron.service-now.com/itserviceportal?id=sc_cat_item_guide&sys_id=9c08a21edb126450182e1dca48961981" target="_blank" rel="noopener noreferrer">Support Request</a></span>
</div>
